import type { BoxProps } from "@mui/material"
import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"

export const ClipBorder = styled(
	({ borderRadius = "inherit", ...props }: BoxProps) => (
		<Box borderRadius={borderRadius} {...props} />
	),
)({ overflow: "hidden", clipPath: "border-box" })
